<template>
  <div v-show="dataLoaded">
    <h2 class="c-title-section-v2">
      <span class="text-eng">Instructor & Class</span>
      <span class="text">講師と授業</span>
    </h2>
    <div class="l-gap--md">
      <div class="u-position--relative">
        <div class="p-archive-slider swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(post, index) in posts" :key="index">
              <article class="p-archive-item-blog">
                <div class="p-archive-item-blog__inner">
                  <div class="p-archive-item-blog__thumb">
                    <img :src="post.image" alt="" width="360" height="240" loading="lazy">
                    <time class="p-archive-item-blog__date" :datetime="post.createdAt"><span class="year">{{ new
                      Date(post.createdAt).getFullYear() }}</span><span class="date">{{ formatDate(post.createdAt)
  }}</span></time>
                  </div>
                  <div class="p-archive-item-blog__body">
                    <a :href="post.url" class="p-archive-item-blog__title" target="_blank">
                      <div class="p-archive-item-blog__title__inner js-fix-height-box__item" data-height-group="1">
                        <h3 class="p-archive-item-blog__title__text">{{ post.title }}</h3>
                        <span class="p-archive-item-blog__category c-title-obi c-title-obi--category"><span>{{
                          post.category }}</span></span>
                      </div>
                    </a>
                    <ul class="c-list-text-tags">
                      <li v-for="tag in post.tags" :key="tag.id"><a :href="'/media/blog_tag/' + tag.slug + '/'"
                          target="_blank">{{ tag.name }}</a></li>
                    </ul>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
        <div class="p-nav-swiper-container u-visible--sm">
          <button type="button"
            class="p-nav-swiper-around-nav-block p-nav-swiper-around-nav-block__prev swiper-button-prev" aria-label="前へ">
            <span class="c-icon">
              <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/icon_arrow_circle.svg" alt="" width="60"
                height="60" loading="lazy">
            </span>
          </button>
          <button type="button"
            class="p-nav-swiper-around-nav-block p-nav-swiper-around-nav-block__next swiper-button-next" aria-label="次へ">
            <span class="c-icon">
              <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/icon_arrow_circle.svg" alt="" width="60"
                height="60" loading="lazy">
            </span>
          </button>
        </div>
        <div class="p-nav-swiper-container p-nav-swiper-pagination-container u-visible--sm-down">
          <button type="button" class="p-nav-swiper-around-nav p-nav-swiper-around-nav__prev swiper-button-prev"
            aria-label="前へ">
            <span class="c-icon">
              <i class="material-symbols-outlined" aria-hidden="true">chevron_right</i>
            </span>
          </button>
          <div class="swiper-pagination p-nav-swiper-pagination"></div>
          <button type="button" class="p-nav-swiper-around-nav p-nav-swiper-around-nav__next swiper-button-next"
            aria-label="次へ">
            <span class="c-icon">
              <i class="material-symbols-outlined" aria-hidden="true">chevron_right</i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="p-articles-section__deco-1">
      <div class="c-anim-arrow js-lottie-course"
        data-lottie-json="/nbl/cms/wp-content/themes/isi-nbl/assets/json/anim-dot-arrow.json" data-lottie-loop="true"
        data-lottie-observer="false"></div>
    </div>
    <span class="p-articles-section__deco-4">
      <img src="/nbl/cms/wp-content/themes/isi-nbl/assets/img/shared/deco10@2x.webp" alt="" width="165" height="165"
        loading="lazy">
    </span>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

import ArchiveSlider from './ArchiveSlider';
import lottieImage from './lottieImage';

// API
const posts = ref({});
const dataLoaded = ref(false);

const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月を2桁にする
  const day = date.getDate().toString().padStart(2, '0'); // 日を2桁にする
  return `${month}${day}`;
};

const currentUrl = window.location.pathname;
const urlParts = currentUrl.split('/').filter(part => part !== '');

const course = urlParts[urlParts.length - 1];

const params = {
  taxonomy: 'blog_cat',
  category: 'nbl-instructor-class',
  tag: 'nbl-' + course,
  perPage: 10,
};

const apiGet = async () => {
  const response = await api.get('/media/api/', { params });
  posts.value = response.data.posts;
};

onMounted(async () => {
  await apiGet();
  if (posts.value.length > 0) {
    dataLoaded.value = true;
    const ArchiveSliderElem = document.querySelectorAll('#instructor-course .p-archive-slider');
    if (!ArchiveSliderElem.length) return;
    for (let i = 0; i < ArchiveSliderElem.length; i++) {
      new ArchiveSlider(ArchiveSliderElem[i], i);
    }
    const lottieLoader = document.getElementsByClassName('js-lottie-course');
    const observeLottieAnimation = () => {
        if (!lottieLoader.length) return;
        for (let i = 0; i < lottieLoader.length; i++) {
          new lottieImage(lottieLoader[i]);
        }
    }
    observeLottieAnimation();
  }
});
</script>
